import { UserOutlined } from '@ant-design/icons';
import { Avatar, Tooltip } from 'antd';
import { AvatarSize } from 'antd/es/avatar/AvatarContext';
import React from 'react';

export type UserAvatarProps = {
  url?: string;
  firstName?: string;
  lastName?: string;
  size?: AvatarSize;
  className?: string;
};

const UserAvatar: React.FC<UserAvatarProps> = ({
  size,
  className,
  url,
  firstName,
  lastName,
}) => {
  const fn = firstName ?? '';
  const ln = lastName ?? '';

  if (url) {
    return <Avatar size={size} className={className} src={url} alt="avatar" />;
  }
  if (fn.length > 0 || ln.length > 0) {
    return (
      <Tooltip title={`${fn} ${ln}`}>
        <Avatar size={size} className={className} alt="avatar">
          {`${fn[0] ?? ''}${ln[0] ?? ''}`}
        </Avatar>
      </Tooltip>
    );
  }

  return (
    <Avatar
      size={size}
      className={className}
      icon={<UserOutlined />}
      alt="avatar"
    />
  );
};

export default UserAvatar;
